import React, { useEffect } from "react";
import { createSearchParams, useSearchParams } from "react-router-dom";

export function useUpdateSearchParam(params: any) {
  const [_, setSearchParams] = useSearchParams();
  useEffect(() => {
    setSearchParams(createSearchParams(params as any), { replace: true });
  }, [params]);
}
